export const ACCESS_CACHE_TTL_MS = 15 * 60 * 1000;
export const ACCESS_RETRY_MIN_MS = 60 * 1000;

export function accessIdentityKey(user) {
  return user ? JSON.stringify([user.uid, user.emailVerified === true]) : null;
}

// Firestore-derived objects can arrive with a different property order. A
// successful unchanged refresh must not restart product access/bootstrap reads.
export function accessSnapshotKey(value) {
  return JSON.stringify(value, (_key, item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) return item;
    return Object.keys(item).sort().reduce((sorted, key) => {
      sorted[key] = item[key];
      return sorted;
    }, {});
  });
}

export function isTransientAccessError(error) {
  return ["unavailable", "deadline-exceeded", "resource-exhausted", "internal",
    "network-request-failed"].includes(String(error?.code || "").replace(/^(functions|auth)\//, ""));
}

export function accessRetryAt(error, failures, now) {
  const backoff = Math.min(ACCESS_CACHE_TTL_MS, ACCESS_RETRY_MIN_MS * 2 ** Math.min(failures - 1, 4));
  const serverRetryAt = Number(error?.details?.retryAtMs);
  const serverDelay = Number(error?.details?.retryAfterSeconds);
  return Math.max(now + backoff,
    Number.isFinite(serverRetryAt) ? serverRetryAt : 0,
    Number.isFinite(serverDelay) ? now + serverDelay * 1000 : 0);
}

export function serializableAccessError(error) {
  return {
    code: String(error?.code || "functions/unknown"),
    message: String(error?.message || "Access could not be verified."),
    ...(typeof error?.details?.reason === "string" ? { details: { reason: error.details.reason } } : {}),
  };
}
